<script setup lang="ts">
import { HiddenField } from "@formwerk/core";

defineProps<{ productId: number }>();
const { account } = useAccount();
const { onSubmit, isSubmitting, result } = useAddToWaitlistForm();
</script>

<template>
  <div class="flex flex-col gap-4">
    <div class="text-xl font-medium">
      Vous désirez recevoir une alerte lorsque l'item sera disponible?
    </div>
    <UiFormWrapper :result="result" @submit="onSubmit">
      <HiddenField name="product_id" :value="productId" />
      <FieldText name="email" type="email" label="Votre adresse courriel" readonly required :value="account?.email" />
      <UiSubmitButton :is-submitting="isSubmitting">
        Avisez-moi
      </UiSubmitButton>
    </UiFormWrapper>
  </div>
</template>
